module.exports = __webpack_public_path__ + "static/img/en@3x.f652937.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/en@3x.png
// module id = 734
// module chunks = 0 1 3 4